// extracted by mini-css-extract-plugin
export default {"easyTrading":"EasyTrading_easyTrading__nZnK2","title":"EasyTrading_title__j9vtc","content":"EasyTrading_content__3i9ft"};